/**
 * Marque de l'app : logo Greenkub (wordmark) + « /poseurs ».
 * Le SVG utilise currentColor → couleur du texte (foreground). « /poseurs » est
 * dans le jaune Greenkub, légèrement plus petit que le logo (mirror Brand relais).
 */
export function Brand() {
  return (
    <span className="flex items-end gap-1.5">
      <GreenkubWordmark
        className="h-7 w-auto"
        style={{ color: "rgb(65, 184, 131)" }}
      />
      <span
        className="text-lg font-bold leading-none"
        style={{ color: "rgb(254, 221, 99)" }}
      >
        /poseurs
      </span>
    </span>
  );
}

function GreenkubWordmark({
  className,
  style,
}: {
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 142 39"
      fill="none"
      className={className}
      style={style}
      role="img"
      aria-label="Greenkub"
    >
      <path
        d="M15.6507 13.6273C14.0175 11.902 11.7438 11.0394 9.62942 11.0394C4.14349 11.0394 1.33444 15.3526 1.36155 20.0079C1.36155 24.7506 4.1706 28.8345 9.62942 28.8345C11.6354 28.8345 13.7227 28.0884 15.3288 26.505V20.8706H8.79925V19.5202H16.6944V27.051C14.7392 29.1512 12.4114 30.2978 9.62942 30.2978C3.2591 30.2978 -0.0311127 25.5259 -0.0311127 20.037C-0.0582204 13.7401 3.93001 9.63074 9.62942 9.63074C12.0928 9.63074 14.58 10.6353 16.4809 12.6482L15.6507 13.6273Z"
        fill="currentColor"
      />
      <path
        d="M35.2924 30.0434H33.3914L26.9161 22.4252H21.8063V30.0434H20.3594V9.92236H28.6035C32.6697 9.92236 34.7333 13.0563 34.7604 16.1902C34.7875 19.466 32.7781 22.3415 28.6849 22.3415L35.2958 30.047L35.2924 30.0434ZM21.8063 20.9584H28.4443C31.7108 20.9584 33.1543 18.9746 33.1814 16.1574C33.2085 13.7988 31.7108 11.3565 28.6069 11.3565H21.8096V20.9584H21.8063Z"
        fill="currentColor"
      />
      <path
        d="M39.1176 19.2076H50.0894V20.6126H39.1176V28.5474H50.9467V30.0434H37.7012V9.92236H50.6248V11.3856H39.1176V19.2076Z"
        fill="currentColor"
      />
      <path
        d="M55.5511 19.2076H66.523V20.6126H55.5511V28.5474H67.3803V30.0434H54.1348V9.92236H67.0584V11.3856H55.5511V19.2076Z"
        fill="currentColor"
      />
      <path
        d="M71.769 9.92236L84.3708 26.5637V9.92236H85.7905V30.0434H85.228L72.5958 13.4275V30.0434H71.1523V9.92236H71.769Z"
        fill="currentColor"
      />
      <path
        d="M104.604 10.0352L96.2818 19.6662L105.299 29.8141V30.0434H100.938L93.0967 21.1331V30.0434H89.5625V9.92236H93.0967V18.4287L100.216 9.92236H104.604V10.0352Z"
        fill="currentColor"
      />
      <path
        d="M122.671 9.95105V21.4784C122.671 27.4296 119.272 30.4761 114.562 30.4761C109.852 30.4761 106.24 27.5424 106.24 21.4784V9.95105H109.744V21.4784C109.744 25.1001 111.672 27.0255 114.586 27.0255C117.5 27.0255 119.16 24.929 119.16 21.4784V9.95105H122.668H122.671Z"
        fill="currentColor"
      />
      <path
        d="M141.35 15.757C141.35 17.3112 140.656 18.8036 138.914 19.6371C141.11 20.3578 141.913 22.8584 141.913 24.1214C141.913 28.6057 138.782 30.0434 134.902 30.0434H126.018V9.92236H134.902C138.596 9.92236 141.35 11.7059 141.35 15.757ZM129.494 17.9992H134.899C137.122 17.9992 137.843 16.9909 137.843 15.8444C137.843 14.9235 137.149 13.3729 134.899 13.3729H129.494V17.9992ZM129.494 26.5091H134.899C136.346 26.5091 138.406 25.9923 138.406 24.0959C138.406 22.1995 136.346 21.3369 134.899 21.3369H129.494V26.5091Z"
        fill="currentColor"
      />
    </svg>
  );
}
